import React from "react";
import WhatComesNextForm from "../form/what-comes-next/what-comes-next";
import { Body1, Heading1, Heading2 } from "../typography/typography";
import styled from "styled-components";
import CallToAction from "../button/calltoaction/callToAction";
import { useLocation } from "@reach/router";

const Bold = styled(Body1)`
  display: block;
  font-weight: 500;
  margin-top: 40px !important;
`;

const P = styled(Body1)`
  margin-top: 5px !important;
`;

const Button = styled(CallToAction)`
  margin-top: 15px !important;
`;

function WhatComesNext() {
  const location = useLocation();

  return (
    <div>
      <Heading1>WHAT YOU SHOULD DO NEXT...</Heading1>
      <Bold>
        1. Learn more about how our product, Vorne XL, can help you eliminate
        waste and significantly improve OEE.
      </Bold>
      <P>
        Vorne XL is the simplest and fastest way to monitor and improve
        production. It's a one-time cost and takes just a day to install. And
        you can try it completely free for 90 days.
      </P>
      <Button
        className="custom-button learn"
        url="https://www.vorne.com/products/free-trial/"
      >
        Learn More
      </Button>
      <Bold>
        2. Download our FREE package of tools to supercharge your manufacturing
        productivity
      </Bold>
      <P>
        The package includes leadership lessons, training guides, meeting and
        report templates, summaries of key concepts, project organizers, and
        more. You'll also receive our monthly newsletter for free. Unsubscribe
        at any time.
      </P>
      <Button
        className="custom-button tools"
        url={
          location.origin?.includes("oee.com")
            ? "/free-oee-tools/"
            : "/free-lean-manufacturing-tools/"
        }
      >
        {location.origin?.includes("oee.com")
          ? "DOWNLOAD FREE OEE TOOLS"
          : "DOWNLOAD FREE LEAN TOOLS"}
      </Button>
      <Bold>3. Sign up for our monthly newsletter</Bold>
      <P>
        Get free monthly updates with proven methods for improving our
        manufacturing productivity. Unsubscribe at any time.
      </P>
      <WhatComesNextForm />
    </div>
  );
}

export default WhatComesNext;
